/**
 * uslData.js — USL Super League (Women)
 * 2025–26 season — 10 teams. First fully professional women's league below NWSL.
 */

export const USL_SEASON     = '2025–26';
export const USL_WORKER_URL = 'https://usl-proxy.footballgirl.workers.dev';

export const USL_STANDINGS_FALLBACK = [
  { pos:1,  name:'Sporting Kansas City W.', short:'SKC', color:'#002F6C', zone:'champion', p:14, w:10, d:2, l:2,  gf:34, ga:12, gd:22,  pts:32, form:['W','W','W','D','W'] },
  { pos:2,  name:'DC Power FC',             short:'DCP', color:'#D00027', zone:'top',      p:14, w:9,  d:2, l:3,  gf:28, ga:14, gd:14,  pts:29, form:['W','W','D','W','W'] },
  { pos:3,  name:'Carolina Ascent FC',      short:'CAR', color:'#005EB8', zone:'top',      p:14, w:8,  d:1, l:5,  gf:26, ga:18, gd:8,   pts:25, form:['W','L','W','W','L'] },
  { pos:4,  name:'Dallas Trinity FC',       short:'DAL', color:'#00843D', zone:'n',        p:14, w:6,  d:3, l:5,  gf:22, ga:21, gd:1,   pts:21, form:['W','D','L','W','D'] },
  { pos:5,  name:'Lexington SC Women',      short:'LEX', color:'#0057A8', zone:'n',        p:14, w:6,  d:2, l:6,  gf:19, ga:20, gd:-1,  pts:20, form:['L','W','W','L','W'] },
  { pos:6,  name:'Tampa Bay Sun FC',        short:'TMP', color:'#FF6B00', zone:'n',        p:14, w:5,  d:3, l:6,  gf:18, ga:22, gd:-4,  pts:18, form:['L','D','W','L','D'] },
  { pos:7,  name:'Brooklyn FC Women',       short:'BKN', color:'#231F20', zone:'n',        p:14, w:4,  d:3, l:7,  gf:16, ga:24, gd:-8,  pts:15, form:['L','D','W','L','L'] },
  { pos:8,  name:'Sporting JAX Women',      short:'JAX', color:'#007A33', zone:'n',        p:14, w:4,  d:2, l:8,  gf:18, ga:26, gd:-8,  pts:14, form:['W','L','L','W','L'] },
  { pos:9,  name:'Fort Lauderdale Utd W.',  short:'FTL', color:'#00A0DC', zone:'rel',      p:14, w:3,  d:2, l:9,  gf:14, ga:28, gd:-14, pts:11, form:['L','W','L','L','L'] },
  { pos:10, name:'Chicago Red Stars W.',    short:'CHI', color:'#C8102E', zone:'rel',      p:14, w:2,  d:2, l:10, gf:11, ga:30, gd:-19, pts:8,  form:['L','L','D','L','W'] },
];

export const USL_TOP_SCORERS_FALLBACK = [
  { initials:'SK', name:'Simone Kolander',   club:'DC Power FC',     goals:11 },
  { initials:'AM', name:'Ashley Merrill',    club:'Carolina Ascent', goals:9  },
  { initials:'TH', name:'Trinity Byars',     club:'Dallas Trinity',  goals:7  },
  { initials:'JP', name:'Joelle Pakiz',      club:'Sporting KC W.',  goals:6  },
  { initials:'NR', name:'Nealy Rodriguez',   club:'Tampa Bay Sun',   goals:5  },
  { initials:'LM', name:'Lauren Milliet',    club:'Brooklyn FC',     goals:5  },
];

export const USL_FIXTURES_FALLBACK = [
  { date:'2026-04-06', home:'Fort Lauderdale', homeColor:'#00A0DC', homeGoals:3, awayGoals:1, away:'DC Power FC',    awayColor:'#D00027', status:'FT' },
  { date:'2026-04-12', home:'Carolina Ascent', homeColor:'#005EB8', homeGoals:1, awayGoals:0, away:'Lexington SC',   awayColor:'#0057A8', status:'FT' },
  { date:'2026-04-12', home:'Sporting JAX',    homeColor:'#007A33', homeGoals:4, awayGoals:1, away:'Fort Lauderdale',awayColor:'#00A0DC', status:'FT' },
  { date:'2026-04-18', home:'Lexington SC',    homeColor:'#0057A8', homeGoals:null, awayGoals:null, away:'Tampa Bay Sun',   awayColor:'#FF6B00', status:'NS' },
  { date:'2026-04-18', home:'Brooklyn FC',     homeColor:'#231F20', homeGoals:null, awayGoals:null, away:'Dallas Trinity',  awayColor:'#00843D', status:'NS' },
];

export async function fetchLiveUSLData() {
  if (!USL_WORKER_URL || USL_WORKER_URL.includes('footballgirl')) {
    console.info('[USL] PROXY_URL not set — using fallback data.');
    return null;
  }
  try {
    const r = await fetch(USL_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const d = await r.json();
    return {
      standings:  d.standings  ?? USL_STANDINGS_FALLBACK,
      topScorers: d.topScorers ?? USL_TOP_SCORERS_FALLBACK,
      fixtures:   d.fixtures   ?? USL_FIXTURES_FALLBACK,
    };
  } catch (e) {
    console.warn('[USL] Live fetch failed, using fallback:', e.message);
    return null;
  }
}
